import { Box, Divider, Typography } from '@mui/material';
import { theme } from '@theguarantors/tg-package-material-ui';

type Props = {
  label?: string;
  open?: boolean;
};

export const MenuDivider = ({ label, open }: Props) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        height: '22px',
        lineHeight: '22px',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      {open && label && (
        <Typography
          sx={{
            color: theme.palette.neutralGrey[400],
            fontSize: '14px',
            whiteSpace: 'nowrap',
            fontWeight: 500,
            lineHeight: '22px',
            textTransform: 'uppercase',
            letterSpacing: '0.56px',
          }}
        >
          {label}
        </Typography>
      )}
      <Divider
        sx={{
          flex: 1,
          borderColor: theme.palette.neutralGrey[200],
        }}
      />
    </Box>
  );
};
